<script lang="ts">
	import { fade, fly } from 'svelte/transition';
	import { basketListnew, basketId } from '$lib/store/newbasket';
	import RangeSlider from 'svelte-range-slider-pips';
	import Alert from '$lib/components/NotAler.svelte';
	import { onDestroy, onMount } from 'svelte';
	import { lang } from '$lib/translations/basket';
	import { page } from '$app/stores';
	import arrb from '$lib/images/arrb.svg';
	import { basketList } from '$lib/store/basket';
	import DetailBasket from './DetailBasket.svelte';
	import { goto } from '$app/navigation';
	import { variables } from '$lib/variables';
	import Loader from './Loader.svelte';
	import RangeInp from './RangeInp.svelte';
	import Sign from './Sign.svelte';
	import CreateGiftPay from './forms/CreateGiftPay.svelte';
	let OpenGiftCard = false;
	let alertMessage = false;

	let textalert = '';
	let color = 'rgb(240 253 244)';
	let load = false;

	let promocode = '';
	let errPromocode = '';
	async function GetBasketNew() {
		let urls = `${variables.basePathApi}/api/v1/orders/user-auth/`;
		const res = await fetch(urls, {});
		if (res.status === 200) {
			let baskData = await res.json();
			$basketListnew = baskData;
			$basketId = baskData.id;
		}
		return null;
	}
	async function GetBasket(pk) {
		if ($page.data.access) {
			let url = `${variables.basePathApi}/api/v1/orders/${pk}/for-client/`;
			const res = await fetch(url, {
				headers: {
					Authorization: 'Bearer ' + $page.data.access
				}
			});
			if (res.status === 200) {
				$basketListnew = await res.json();
			} else {
				$basketListnew = null;
				$basketId = null;
				await GetBasketNew();
			}
		} else {
			let url = `${variables.basePathApi}/api/v1/orders/${pk}/for-client/`;
			const res = await fetch(url, {});
			if (res.status === 200) {
				$basketListnew = await res.json();
			} else {
				$basketListnew = null;
				$basketId = null;
				await GetBasketNew();
			}
		}
	}
	async function OnAddCashBack() {
		load = true;
		const url = `${variables.basePathApi}/api/v1/spent-cashback/`;
		const datasend = {
			order: $basketId,
			amount: cachbacksprentvalue[0],
			user: $page.data.user.id
		};

		try {
			const response = await fetch(url, {
				method: 'POST',
				body: JSON.stringify(datasend),
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				}
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const responseData = await response.json();

			await GetBasket($basketId);
			// Handle the response data as needed
		} catch (error) {
			console.error('Error:', error);
		}
		load = false;
	}
	const GoBasket = (url_path) => {
		location.href = url_path
	}
	async function OnClearCashBack() {
		load = true;
		const url = `${variables.basePathApi}/api/v1/delete-spent-cashback/`;
		const datasend = {
			order: $basketId,

			user: $page.data.user.id
		};

		try {
			const response = await fetch(url, {
				method: 'POST',
				body: JSON.stringify(datasend),
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json'
				}
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const responseData = await response.json();

			await GetBasket($basketId);
			// Handle the response data as needed
		} catch (error) {
			console.error('Error:', error);
		}
		load = false;
	}
	async function VerifyPromocode() {
		load = true;
		const res = await fetch(`${variables.basePathApi}/api/v1/promo-code/code/${promocode}/`);
		if (res.status != 200) {
			alertMessage = true;
			textalert = lang[$page.data.host]['errpromo'];
			color = 'red';
			promocode = '';
			load = false;
			return;
		}
		errPromocode = '';
		let results = await res.json();

		let url = `${variables.basePathApi}/api/v1/orders/${$basketId}/`;
		let method = 'PATCH';

		const rest = await fetch(url, {
			method: method,
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				promocodefk: Number(results.id)
			})
		});
		if (rest.status === 201 || rest.status === 200) {
			await GetBasket($basketId);
			load = false;
		}

		return results;
	}

	export let OpenBasket;
	console.log('$page.data.summcachback.total_cashback', $page.data.summcachback.total_cashback);

	let mxcach = Number($page.data.summcachback.total_cashback);
	onMount(async () => {
		if ($basketId) {
			await GetBasket($basketId);
			if (mxcach > Number($basketListnew[`summa${$page.data.host}`])) {
				mxcach = Number($basketListnew[`summa${$page.data.host}`]);
			}
		}
	});
	onDestroy(() => {
		// Ваш код для закрытия модального окна
		document.body.classList.remove('modal-open');
	});
	let cachbacksprentvalue = [1000];
	const currency = new Intl.NumberFormat('de', { style: 'currency', currency: 'RUB' });
	const formatter = (value) => `${Number(value).toLocaleString('ru')} ₽`;
	let signin = false;
	let openAlert = false;
	const GoPage = (url) => {
		localStorage.removeItem('open_basket');
		OpenBasket = false;
		window.location.href = url;
	}
</script>

{#if signin}
	<Sign bind:signin />
{/if}

<div
	style="z-index: 1000"
	class="relative"
	aria-labelledby="slide-over-title"
	role="dialog"
	aria-modal="true"
>
	<!-- Background backdrop, show/hide based on slide-over state. -->
	<div class="fixed bg-custom-black opacity-70 inset-0" />

	<div
		transition:fly={{
			x: 200,
			duration: 500
		}}
		class="fixed inset-0"
	>
		<div class="absolute inset-0 overflow-hidden">
			<div
				class="pointer-events-none fixed inset-y-0 right-0 flex items-end max-w-full md:pl-10 sm:pl-16"
			>
				<div class="pointer-events-auto w-screen h-[100vh] md:h-screen md:w-screen md:max-w-2xl">
					<div class="flex h-full flex-col overflow-y-scroll bg-white py-6 shadow-xl">
						<div class="px-4 sm:px-6">
							<div class="flex items-start justify-between">
								<h2 class="text-base font-semibold leading-6 text-gray-900" id="slide-over-title" />
								<div class="ml-3 hidden md:flex items-center">
									<button
										on:click={() => {
											OpenBasket = false;
											localStorage.removeItem('open_basket');
										}}
										type="button"
										class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
									>
										<span class="sr-only">Close panel</span>
										<svg
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6 18L18 6M6 6l12 12"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
						<div class="relative mt-6 flex-1 px-4 pt-0 md:pt-[19px] sm:px-6">
							<div class="w-full">
								<h2 class="text-2xl hidden md:block text-custom-gray text-left" />
								<div class="flex md:hidden pt-2 justify-between items-center">
									<h2 class="text-2xl text-custom-gray text-left" />
									<button
										on:click={() => {
											OpenBasket = false;
											localStorage.removeItem('open_basket');
										}}
										type="button"
										class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
									>
										<span class="sr-only">Close panel</span>
										<svg
											class="h-6 w-6"
											fill="none"
											viewBox="0 0 24 24"
											stroke-width="1.5"
											stroke="currentColor"
											aria-hidden="true"
										>
											<path
												stroke-linecap="round"
												stroke-linejoin="round"
												d="M6 18L18 6M6 6l12 12"
											/>
										</svg>
									</button>
								</div>

								{#if $basketListnew?.order_items.length > 0}
									<div class="relative mt-6 flex-1 px-4 sm:px-6">
										{#if load}
											<Loader />
										{/if}
										{#if alertMessage}
											<Alert bind:alertMessage bind:textalert bind:color />
										{/if}
										<!-- svelte-ignore a11y-no-redundant-roles -->
										<ul
											role="list"
											class="mt-6 text-sm font-medium text-gray-500 dark:text-gray-50"
										>
											{#each $basketListnew.order_items as item (item.id)}
												<DetailBasket bind:item bind:load />
											{/each}
										</ul>
									</div>
									{#if !$page.data.user}
										<!-- Global notification live region, render this permanently at the end of the document -->

										<div
											class="pointer-events-auto bg-white mb-4 flex w-full divide-x divide-gray-200 rounded-lg shadow-sm ring-1 ring-black ring-opacity-5"
										>
											<div class="flex w-0 flex-1 items-center p-4">
												<div class="w-full">
													<p class="text-sm font-semibold text-gray-900">
														Больше выгоды с Авторизацией в один клик!
													</p>
													<p class="mt-1 text-sm text-gray-500">
														Авторизуйтесь для получения, списания кэшбека и отслеживания ваших
														заказов в личном кабинете.
													</p>
												</div>
											</div>
											<div class="flex">
												<div class="flex flex-col divide-y divide-gray-200">
													<div class="flex h-0 flex-1">
														<button
															on:click={() => {
																signin = true;
																localStorage.setItem('open_basket', '1');
																goto(`?pathname=${$page.url.pathname}`);
															}}
															type="button"
															class="flex w-full items-center justify-center rounded-none rounded-tr-lg border border-transparent px-4 py-3 text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:z-10 focus:outline-none focus:ring-2 focus:ring-indigo-500"
															>Войти</button
														>
													</div>
												</div>
											</div>
										</div>
									{/if}
									<div class="flex flex-col gap-[29px]">
										<div class="flex justify-between items-center">
											<span class="text-[12px] text-custom-black"
												>{lang[$page.data.host]['tosumm']}
											</span>

											<span> {Number($basketListnew.summa).toLocaleString('ru')} ₽</span>
										</div>
										<!-- Если есть кешбек -->
										{#if !$basketListnew.pre_order}
											{#if $page.data.cashbacksale}
												<div class="flex justify-between items-center w-full">
													<span>Начислен кэшбек: </span>

													<span class="text-green-500">+ {$basketListnew.calculate_cashback} ₽</span
													>
												</div>
											{/if}
											{#if !$basketListnew.promocodefk?.code}
												<div class="flex justify-between gap-3 items-center">
													<div class="h-[10vh]">
														{#if promocode}
															<button
																on:click={() => {
																	VerifyPromocode();
																}}
																class="text-[12px] text-custom-white-bg py-3 md:py-[10px] px-3 bg-custom-black"
															>
																{lang[$page.data.host]['confpromocode']}
															</button>
														{:else}
															<button class="text-[12px] text-custom-black"
																>+ {lang[$page.data.host]['addpromo']}</button
															>
														{/if}
													</div>
													<div class="w-[50%] h-[10vh]">
														<div class="relative">
															<label for="email" class="sr-only"
																>{lang[$page.data.host]['promocode']}</label
															>
															<input
																type="text"
																bind:value={promocode}
																name="email"
																id="email"
																class="block px-2 w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
																placeholder={lang[$page.data.host]['promocode']}
															/>
															{#if errPromocode}
																<span class="text-red-500 absolute text-[8px]">{errPromocode}</span>
															{/if}
														</div>
													</div>
												</div>
											{/if}
											{#if Number($page.data.summcachback.total_cashback) > 0 && !Number($basketListnew.amount_cashback_sprent)}
												<div class="flex flex-col gap-3">
													<span
														>Ваш кэшбек: <span class="text-green-500"
															>{Number($page.data.summcachback.total_cashback).toLocaleString('ru')}
															₽</span
														>
													</span>
													<RangeSlider
														first="label"
														last="label"
														{formatter}
														float
														min={0}
														max={mxcach}
														step={1}
														bind:values={cachbacksprentvalue}
													/>

													<div class="h-[30px] text-end">
														{#if cachbacksprentvalue > 0}
															<button
																on:click={() => {
																	OnAddCashBack();
																}}
																class="text-[12px] text-custom-white-bg py-3 md:py-[10px] px-3 bg-custom-black"
															>
																Оплатить баллами {cachbacksprentvalue} ₽
															</button>
														{/if}
													</div>
												</div>
											{/if}
											{#if $basketListnew.promocodefk?.code}
												<div class="flex justify-between items-center">
													<span class="text-[12px] text-custom-black"
														>{lang[$page.data.host]['salepromo']} ({$basketListnew.promocodefk
															.sale}% )</span
													>

													<span
														>- {(
															Number($basketListnew[`summa${$page.data.host}`]) -
															Number($basketListnew[`summa_promocode${$page.data.host}`])
														).toLocaleString('ru')}
														₽</span
													>
												</div>
											{/if}
											{#if Number($basketListnew.amount_cashback_sprent) > 0}
												<div class="flex justify-between items-center">
													<span
														class="text-[12px] text-custom-black inline-flex items-center gap-2 p-2"
														>Кэшбек применен <button
															on:click={() => OnClearCashBack()}
															class="rounded bg-indigo-600 px-2 py-1 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
														>
															<!-- <svg
															class="h-6 w-6 text-white"
															fill="none"
															viewBox="0 0 24 24"
															stroke-width="1.5"
															stroke="currentColor"
															aria-hidden="true"
														>
															<path
																stroke-linecap="round"
																stroke-linejoin="round"
																d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99"
															/>
														</svg> -->
															Изменить сумму
														</button>
													</span>

													<span
														>- {Number($basketListnew.amount_cashback_sprent).toLocaleString('ru')}
														₽</span
													>
												</div>
											{/if}
										{/if}

										<div class="flex justify-between items-center">
											<span class="text-[12px] text-custom-black"
												>{lang[$page.data.host]['itogo']}</span
											>
											{#if !$basketListnew.promocodefk?.code}
												<span>
													{(
														Number($basketListnew.summa) -
														Number($basketListnew.amount_cashback_sprent) -
														Number($basketListnew.gift_card_summa)
													).toLocaleString('ru')}
													₽</span
												>
											{:else}
												<span>
													{Number(
														$basketListnew.summa_promocode -
															Number($basketListnew.amount_cashback_sprent) -
															Number($basketListnew.gift_card_summa)
													).toLocaleString('ru')}
													₽</span
												>
											{/if}
										</div>

										<div class="flex justify-end">
											<button
												on:click={() => {
													if (!$page.data.user) {
														openAlert = true;
													} else {
														
													
														GoBasket(`https://adminapp.iloveitalianbags.ru/cart/${$basketListnew.id}`)
														
														OpenBasket = false;
													}
												}}
												class="border-solid flex justify-center md:justify-around items-center border-1 border-custom-black w-full md:w-[200px] bg-custom-black text-custom-white-bg py-[14px] text-base md:text-[10px] font-normal text-center"
												><span>
													{#if !$basketListnew.pre_order}
														{lang[$page.data.host]['confzakaz']}
													{:else}
														Оформить предзаказ
													{/if}
												</span>
												<img class="hidden md:block" src={arrb} alt="" /></button
											>
										</div>
									</div>
								{:else}
									<div class="h-[60vh] w-full flex flex-col justify-center items-center">
										<h2 class="text-custom-gray text-2xl">{lang[$page.data.host]['notBasker']}</h2>
										<button
											on:click={() => {
												goto('/sumki');
												OpenBasket = false;
												localStorage.removeItem('open_basket');
											}}
											type="button"
											class="rounded-md w-full mt-4 bg-custom-black px-3 py-3 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
											>Каталог</button
										>
									</div>
								{/if}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
{#if openAlert}
	<div class="relative z-[2000]" aria-labelledby="modal-title" role="dialog" aria-modal="true">
		<div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

		<div class="fixed inset-0 z-10 w-screen overflow-y-auto">
			<div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
				<div
					class="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6"
				>
					<div class="sm:flex sm:items-start">
						<div
							class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
						>
							<svg
								class="h-6 w-6 text-red-600"
								fill="none"
								viewBox="0 0 24 24"
								stroke-width="1.5"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
								/>
							</svg>
						</div>
						<div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
							<h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">
								Внимание
							</h3>
							<div class="mt-2">
								<p class="text-sm text-gray-500">
									Если вы хотите получить кэшбек с этой покупки и отслеживать ваш заказ в личном
									кабинете выполните вход в один клик.
								</p>
							</div>
						</div>
					</div>
					<div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
						<button
							on:click={() => {
								openAlert = false;
								OpenBasket = false;
								localStorage.removeItem('open_basket');
								
								GoBasket(`https://adminapp.iloveitalianbags.ru/cart/${$basketListnew.id}`);
							}}
							type="button"
							class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
							>Продолжить без авторизации</button
						>

						<button
							on:click={() => {
								signin = true;
								localStorage.setItem('open_basket', '1');
								goto(`?pathname=${$page.url.pathname}`);
							}}
							type="button"
							class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
							>Войти</button
						>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}

<style>
	input:focus {
		border: none;
		outline: none;
	}
</style>
